<template>
  <Transition name="fade">
    <div class="vdbase" v-if="show" @click="hideVideo" >
      <div class="exitBtn" @click.stop="hideVideo"></div>
      <video ref="videotarget" class="vdvideo" src="../assets/image/demo.mp4" controls autoplay @click.stop="pauseVideo"></video>
    </div>
  </Transition>
</template>
<script>
export default {
  data(){
    return {
      show:false
    }
  },
  methods: {
    initKeydowm(){
      document.addEventListener('keydown',()=>{
        //esc退出视频播放
        if(event.keyCode === 27&&this.show){
          this.hideVideo();
        }
      })
    },
    
    pauseVideo(){
      //播放或暂停视频
      if(this.$refs.videotarget.paused){
        this.$refs.videotarget.play();
      }else{
        this.$refs.videotarget.pause();
      }
    },
    showVideo(){
      this.show = true;
      this.$nextTick(()=>{
        this.$refs.videotarget.play();
      })
    },
    hideVideo(){
      this.$refs.videotarget.pause();
      this.$refs.videotarget.currentTime = 0;
      this.show = false;
    }
  },
  mounted(){
    this.initKeydowm();
  },
}
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.vdbase{
  position: fixed;
  top: 0;
  left: 0;
  bottom:0;
  right:0;
  z-index: 900;
  background-color: #000000a8;
  transition: all 0.5s ease-in-out 0s;
}
.vdnone{
  display: none;
}
.vdhid{
  background-color: transparent;
}
.vdshow{
  display: inline-block;
}
.vdvideo{
  z-index: 10;
  width: 100%; height: 100%;
  object-fit: contain;
  position: absolute;
  transition: all 0.5s ease-in-out 0s;
  top:50%;
  left: 50%;
  transform: translate(-50%,-50%);
  // height: 30%;
}
.exitBtn{
  cursor: pointer;
  width: 30px;
  height: 30px;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 11;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;
}

.exitBtn:hover {
  background-color: rgba(255, 255, 255, 1);
}

.exitBtn::before,
.exitBtn::after {
  content: '';
  position: absolute;
  width: 16px;
  height: 2px;
  background-color: #333;
  border-radius: 1px;
}

.exitBtn::before {
  transform: rotate(45deg);
}

.exitBtn::after {
  transform: rotate(-45deg);
}
</style>